<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-one-quarter">
            <b-menu>
              <b-menu-list
                v-if="isActive({ activeModule: 'ges-emissions-factors' })"
                :label="$t('viewDocumentation.label-1')"
              >
                <b-menu-item
                  class="menubackitem"
                  @click="activate({ activeModule: 'ges-methodology' })"
                  :active="isActive({ activeModule: 'ges-methodology' })"
                >
                  <template slot="label">
                    <nav class="level">
                      <div class="level-left">
                        <div class="level-item" style="color: #fff">
                          <b-icon icon="arrow-left"></b-icon>
                        </div>
                      </div>
                    </nav>
                  </template>
                </b-menu-item>
              </b-menu-list>
              <div v-if="!isActive({ activeModule: 'ges-emissions-factors' })">
                <component
                  v-for="(activeApp, index) in activeApps"
                  :key="index"
                  :value="currentModule"
                  @input="(value) => updateMenu(activeApp.name, value)"
                  :is="activeApp.name + '-menu'"
                />
              </div>
              <!-- <b-menu-list
                v-if="!isActive({ activeModule: 'ges-emissions-factors' })"
                :label="$t('viewDocumentation.label-2')"
              >
                <b-menu-item
                  :active="isActive({ activeModule: 'webinar' })"
                  @click="activate({ activeModule: 'webinar' })"
                >
                  <template slot="label">
                    <nav class="level">
                      <div class="level-left">
                        <div class="level-item">
                          <b-icon icon="play-circle-o"></b-icon>
                          {{ $t('viewDocumentation.label-4') }}
                        </div>
                      </div>
                    </nav>
                  </template>
                </b-menu-item>
                <b-menu-item
                  :active="isActive({ activeModule: 'links' })"
                  @click="activate({ activeModule: 'links' })"
                >
                  <template slot="label">
                    <b-icon icon="external-link-square"></b-icon>
                    {{ $t('viewDocumentation.label-3') }}
                  </template>
                </b-menu-item>
              </b-menu-list> -->
            </b-menu>
          </div>
          <div class="column">
            <div v-for="(activeApp, index) in activeApps" :key="index">
              <component
                :is="activeApp.name + '-wrapper'"
                :activeModule="routeParams.activeModule"
                v-if="routeParams.app === activeApp.name"
              />
            </div>
            <!-- others -->
            <links v-if="isActive({ activeModule: 'links' })" />
            <webinar v-if="isActive({ activeModule: 'webinar' })" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'Documentation',
  components: {
    links: () => import('@/components/admin/Links.vue'),
    webinar: () => import('@/components/admin/Webinar.vue')
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  data: () => {
    return {
      _currentModule: ''
    }
  },
  computed: {
    activeApps: function () {
      return this.coreStore.activeAppsWithDocumentation
    },
    routeParams: function () {
      let { app, activeModule } = this.$route.params
      let r = { app, activeModule }
      if (app === undefined && activeModule === undefined) {
        // default
        r = { app: 'carbon', activeModule: 'ges-methodology' }
      }
      return r
    },
    currentModule: {
      get () {
        return this.routeParams.activeModule
      },
      set (value) {
        this._currentModule = value
      }
    }
  },
  methods: {
    updateMenu (app, activeModule) {
      this.currentModule = activeModule
      this.activate({ app, activeModule })
    },
    isActive: function (o) {
      // compare against routeParams
      return (
        o.app === this.routeParams.app &&
        o.activeModule === this.routeParams.activeModule
      )
    },
    activate: function ({ app, activeModule }) {
      // this.activeModule = val
      if (app === undefined && activeModule === undefined) {
        this.$router.push({ name: 'documentation' })
      } else if (app === undefined) {
        console.log('documentation-named')
        this.$router.push({
          name: 'documentation-named',
          params: { activeModule }
        })
      } else {
        this.$router.push({
          name: 'documentation-app-named',
          params: { app, activeModule }
        })
      }
    }
  },
  beforeMount () {
    for (let app of this.activeApps) {
      Vue.component(app.name + '-menu', () =>
        import('@/components/' + app.name + '/docs/Menu.vue')
      )
      Vue.component(app.name + '-wrapper', () =>
        import('@/components/' + app.name + '/docs/Wrapper.vue')
      )
    }
  }
}
</script>

<style>
.menu-list a.is-active {
  background-color: rgba(52, 59, 64, 0.7) !important;
  color: white;
}
.menubackitem {
  max-width: 50px;
  border-radius: 5px;
  background-color: rgb(70, 128, 223, 1);
}
.menubackitem :hover {
  border-radius: 5px;
  background-color: rgb(70, 128, 223, 1) !important;
  cursor: pointer;
}
.b-tabs .tabs {
  overflow: visible;
}
</style>
